// @flow strict

import { apiUrl } from '../../core/api/apiConfig';
import { createAxiosInstance } from '../../core/api/apiClient';
import type {
  UpflowyCreateSubscriptionData,
  CreateSubscriptionResponse,
  CreateSubscriptionDto,
} from './types';

const kenticoFreeTrialInstance = createAxiosInstance(apiUrl.kenticoFreeTrial);

export const provisioning = {
  createSubscription: ({
    customerId,
    signupUserId,
    provisioningType,
    recaptchaAction,
    recaptchaToken,
  }: UpflowyCreateSubscriptionData) =>
    kenticoFreeTrialInstance.post<{ dto: CreateSubscriptionDto }, CreateSubscriptionResponse>(
      '/provisioning',
      {
        dto: {
          CustomerId: customerId,
          SignupUserId: signupUserId,
          ProvisioningType: provisioningType,
          RecaptchaAction: recaptchaAction,
          RecaptchaToken: recaptchaToken,
          CustomerType: null,
          ExtraRequest: null,
          Industry: null,
          IndustryId: null,
          OutcomeStage: null,
          OutcomeSubtype: null,
          OutcomeType: null,
          SubIndustry: null,
          SubIndustryId: null,
          TransactionType: null,
          TransactionTypeId: null,
          TransactionTypeOther: null,
        },
      },
    ),
};
